const $togglePromo = $("#togglePromo");
const $promoForm = $("#formPromoCode");
const $cancelButton = $("#cancelPromo");
import resetForm from "../utils/resetForm";

function togglePromo() {
    $("body").toggleClass("discount-code-form-open");
}

$togglePromo.on("click", function (e) {
    e.preventDefault();
    togglePromo();
});

$cancelButton.on("click", function (e) {
    e.preventDefault();
    togglePromo();
    resetForm($promoForm);
});

